import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { useFeatures, useInsightsTrial } from "./hooks";
import {
  Icon,
  SnoozeOptions,
  UpgradeButton,
  WorkspaceBanner,
} from "./components";

export function InsightsBanner({ user, children }) {
  const { insightsBanner } = useFeatures("insights-upgrade-plan") || {};
  const { showBanner, expirationMessage, expirationDate, snoozeBanner } =
    useInsightsTrial(
      useMemo(() => {
        return user;
      }, [user])
    );

  return (
    <React.Fragment>
      <WorkspaceBanner
        visible={showBanner}
        title={expirationMessage}
        action={
          <UpgradeButton
            data-dd-action-name="change-plan-from-insights-banner"
            upgradeSubject="Upgrade My Plan - Enable Insights"
            description="I am interested in the Insights feature."
            email={user?.email}
            onClick={() => {}}
            inverted
            primary={false}
          />
        }
        dismissComponent={
          <SnoozeOptions
            expirationDate={expirationDate}
            onSnooze={snoozeBanner}
          />
        }
      >
        <span style={{ marginRight: "5px" }}>
          {insightsBanner?.text ||
            "Please upgrade your plan to keep enjoying the Insight Dashboard feature"}
          .
        </span>
        <a
          href={
            insightsBanner?.infoButton?.link ||
            "https://help.myhubly.com/en/collections/4196902-insight-dashboards"
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white" }}
        >
          <span style={{ textDecoration: "underline" }}>
            {insightsBanner?.infoButton?.text || "Learn more"}
          </span>
          <Icon name="external" size="small" style={{ marginLeft: "5px" }} />
        </a>
      </WorkspaceBanner>
      {children}
    </React.Fragment>
  );
}

InsightsBanner.propTypes = {
  user: PropTypes.shape({ email: PropTypes.string }),
  children: PropTypes.node,
};

InsightsBanner.defaultProps = { user: {}, children: undefined };

export default InsightsBanner;
